<template>
  <div class="profile-page-container" :class="{'user-profile-page' : !currentUsername}">

    <div class="back" @click="back">
      <BackIcon/>
    </div>

    <div class="profile-background-image"
         :style="user.background ? `background-color: ${$store.state.siteMode === 'light' ? '#202429' : ''}; background-image: url(${user.background}); background-repeat: no-repeat;`: ''">

      <div v-if="authUser.id !== user.id" class="profile_actions" :class="{active: actions}"
           @click="actions = !actions">
        <div class="profile_actions_btn">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <ul class="actions_list">
          <li v-if="authenticated" @click="reportStatus = true" class="red">
            <span>Report</span>
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.99576 6.05542V25.8048" stroke="#FF0000" stroke-width="1.8" stroke-linecap="round"
                    stroke-linejoin="round"/>
              <path
                  d="M4.99707 20.4022C7.63859 18.8927 10.8409 18.731 13.6211 19.9666L15.581 20.8377C18.3612 22.0734 21.5635 21.9116 24.2051 20.4022V6.055C21.5635 7.56445 18.3612 7.72618 15.5811 6.49056L13.6211 5.61946C10.8409 4.38383 7.63859 4.54556 4.99707 6.055"
                  stroke="#FF0000" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </li>

          <li v-if="authenticated" @click="blockUser" class="red">
            <span>{{ blocked ? 'Unblock' : 'Block' }}</span>
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8361 7.36328L7.5625 22.6369L22.8361 7.36328Z"
                    stroke="#FF0000" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M15.2004 4.19995V4.19995C9.23519 4.19995 4.40039 9.03475 4.40039 15V15C4.40039 20.9652 9.23519 25.8 15.2004 25.8V25.8C21.1656 25.8 26.0004 20.9652 26.0004 15V15C26.0004 9.03475 21.1656 4.19995 15.2004 4.19995Z"
                    stroke="#FF0000" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </li>
          <li @click="copyProfileUrl(false)">
            <span>Copy Profile URL</span>
            <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M19.2004 22.2H21.6004C22.9259 22.2 24.0004 21.1254 24.0004 19.8V6.59995C24.0004 5.27447 22.9259 4.19995 21.6004 4.19995H10.8004C9.47491 4.19995 8.40039 5.27447 8.40039 6.59995V8.99995"
                  stroke="black" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M18.431 11.9645L16.2353 9.76884C15.743 9.27656 15.0754 9 14.3792 9H7.1998C5.87432 9 4.7998 10.0745 4.7998 11.4V23.4C4.7998 24.7255 5.87432 25.8 7.1998 25.8H16.7998C18.1253 25.8 19.1998 24.7255 19.1998 23.4V13.8206C19.1998 13.1244 18.9232 12.4568 18.431 11.9645Z"
                    stroke="black" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M19.1998 14.4H15.5998C14.6057 14.4 13.7998 13.5941 13.7998 12.6V9" stroke="black"
                    stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </li>
          <li>
            <span>Share this Profile</span>
            <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M18.2013 11.3987H20.6023C21.9283 11.3987 23.0033 12.4736 23.0033 13.7997V23.4037C23.0033 24.7297 21.9283 25.8047 20.6023 25.8047H8.59729C7.27125 25.8047 6.19629 24.7297 6.19629 23.4037V13.7997C6.19629 12.4736 7.27125 11.3987 8.59729 11.3987H10.9983"
                  stroke="black" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14.6003 18.6018V4.1958" stroke="black" stroke-width="1.8" stroke-linecap="round"
                    stroke-linejoin="round"/>
              <path d="M18.202 7.7973L14.6005 4.1958L10.999 7.7973" stroke="black" stroke-width="1.8"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </li>
          <li v-if="user.is_x_connected" @click="copyXUrl" class="blue">
            <span>User’s X Page</span>
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M23.3 10.9084C23.3 10.4114 22.8971 10.0084 22.4 10.0084C21.9029 10.0084 21.5 10.4114 21.5 10.9084H23.3ZM4.22678 18.7776C3.93361 18.3762 3.37056 18.2885 2.96917 18.5817C2.56777 18.8748 2.48004 19.4379 2.77322 19.8393L4.22678 18.7776ZM3.34708 18.4215C2.85725 18.506 2.52863 18.9715 2.61309 19.4614C2.69754 19.9512 3.16309 20.2798 3.65292 20.1954L3.34708 18.4215ZM6.65 18.2584L6.93595 19.1118C7.23064 19.0131 7.45353 18.7693 7.52552 18.4669C7.59751 18.1646 7.50842 17.8465 7.28986 17.6255L6.65 18.2584ZM5.6 5.65845L6.3927 5.23226C6.24556 4.95859 5.96766 4.78017 5.65758 4.76029C5.3475 4.74041 5.0491 4.88188 4.86822 5.13453L5.6 5.65845ZM11.9 10.9084L11.6875 11.783C11.9507 11.847 12.2287 11.789 12.4444 11.6251C12.6601 11.4612 12.7906 11.2089 12.7995 10.9382L11.9 10.9084ZM21.35 7.75845L20.5986 8.25377C20.7651 8.5064 21.0474 8.65845 21.35 8.65845V7.75845ZM24.5 7.75845L25.2488 8.25768C25.433 7.98151 25.4501 7.62642 25.2935 7.33377C25.1369 7.04113 24.8319 6.85845 24.5 6.85845V7.75845ZM21.6512 10.4092C21.3754 10.8228 21.4872 11.3816 21.9008 11.6573C22.3143 11.933 22.8731 11.8213 23.1488 11.4077L21.6512 10.4092ZM21.5 10.9084C21.5 14.4178 20.4981 17.3386 18.7064 19.3692C16.927 21.3859 14.2962 22.6084 10.85 22.6084V24.4084C14.7538 24.4084 17.898 23.006 20.0561 20.5602C22.2019 18.1283 23.3 14.7491 23.3 10.9084H21.5ZM10.85 22.6084C8.9235 22.6084 7.63691 22.111 6.6698 21.4267C5.6752 20.7229 4.96431 19.7874 4.22678 18.7776L2.77322 19.8393C3.50219 20.8373 4.3663 22.0018 5.63008 22.8961C6.92134 23.8098 8.5765 24.4084 10.85 24.4084V22.6084ZM3.65292 20.1954C3.68142 20.1904 3.70349 20.1852 3.7111 20.1834C3.72148 20.1809 3.72987 20.1786 3.7349 20.1773C3.74496 20.1746 3.75314 20.1722 3.75738 20.171C3.76638 20.1683 3.77455 20.1658 3.77979 20.1642C3.79108 20.1606 3.80421 20.1564 3.81745 20.1522C3.84462 20.1434 3.88177 20.1312 3.92643 20.1165C4.0162 20.087 4.14174 20.0454 4.29041 19.996C4.58799 19.897 4.98122 19.7658 5.37296 19.6349C5.7648 19.5039 6.15554 19.3731 6.44829 19.2751C6.59468 19.2261 6.71658 19.1853 6.80189 19.1567C6.84454 19.1424 6.87805 19.1312 6.9009 19.1236C6.91232 19.1197 6.92108 19.1168 6.92698 19.1148C6.92994 19.1138 6.93218 19.1131 6.93368 19.1126C6.93443 19.1123 6.93499 19.1121 6.93537 19.112C6.93556 19.1119 6.93571 19.1119 6.9358 19.1119C6.93585 19.1118 6.93589 19.1118 6.93591 19.1118C6.93593 19.1118 6.93595 19.1118 6.65 18.2584C6.36405 17.4051 6.36404 17.4051 6.36402 17.4051C6.364 17.4051 6.36396 17.4051 6.36391 17.4051C6.36382 17.4052 6.36368 17.4052 6.36349 17.4053C6.36312 17.4054 6.36255 17.4056 6.36181 17.4058C6.36031 17.4063 6.35808 17.4071 6.35514 17.4081C6.34925 17.41 6.3405 17.413 6.32909 17.4168C6.30628 17.4244 6.2728 17.4357 6.23019 17.4499C6.14495 17.4785 6.02313 17.5193 5.87685 17.5682C5.58426 17.6662 5.19385 17.7968 4.80242 17.9277C4.41088 18.0585 4.01873 18.1894 3.72252 18.2879C3.57428 18.3372 3.45082 18.3781 3.3637 18.4068C3.31991 18.4212 3.28665 18.4321 3.26445 18.4392C3.25301 18.4429 3.24673 18.4449 3.24423 18.4457C3.24259 18.4462 3.24528 18.4453 3.25026 18.4439C3.25249 18.4432 3.25903 18.4413 3.26781 18.439C3.2722 18.4378 3.28005 18.4357 3.28997 18.4333C3.29714 18.4316 3.31884 18.4264 3.34708 18.4215L3.65292 20.1954ZM7.28986 17.6255C4.09749 14.3981 3.8588 9.63649 6.33178 6.18237L4.86822 5.13453C1.8952 9.28707 2.18851 15.0278 6.01014 18.8914L7.28986 17.6255ZM4.8073 6.08463C6.18649 8.6499 8.78123 11.0767 11.6875 11.783L12.1125 10.0339C9.82477 9.47789 7.59651 7.47133 6.3927 5.23226L4.8073 6.08463ZM12.7995 10.9382C12.8432 9.61834 13.3087 8.52889 14.0461 7.77542C14.7786 7.02687 15.8287 6.55845 17.15 6.55845V4.75845C15.3785 4.75845 13.8537 5.39836 12.7596 6.51647C11.6702 7.62967 11.0572 9.16522 11.0005 10.8787L12.7995 10.9382ZM17.15 6.55845C18.0867 6.55845 18.7711 6.7362 19.2953 7.01595C19.8175 7.29466 20.2363 7.70421 20.5986 8.25377L22.1014 7.26312C21.6085 6.51536 20.9802 5.8749 20.1427 5.42794C19.3072 4.98202 18.3191 4.75845 17.15 4.75845V6.55845ZM21.35 8.65845H24.5V6.85845H21.35V8.65845ZM23.7512 7.25922L21.6512 10.4092L23.1488 11.4077L25.2488 8.25768L23.7512 7.25922Z" fill="#00AFF0"/>
            </svg>
          </li>
        </ul>
      </div>

      <div v-if="currentUsername" class="edit-area-mask"></div>
      <div v-if="currentUsername" class="edit-area">
        <img @click="editUserBackgroundImage" src="/svg/pen-white.svg" alt="edit"/>

        <input
            type="file"
            id="uploadUserBackgroundImage"
            style="display:none;"
            @change="updateUserImage($event, 'background_image')"
        />
      </div>
    </div>

    <div class="th-container">
      <div class="profile_top">
        <div class="profile_left">
          <div class="profile_image_block">
            <div class="profile-avatar">
              <img v-if="user.avatar" class="avatar" :src="user.avatar" alt="avatar"/>
              <img v-else class="avatar" src="@assets/images/user-default.png" alt="avatar"/>
              <div v-if="currentUsername" class="edit-area">
                <img @click="editUserImage" src="/svg/pen-white.svg" alt="edit"/>
                <input
                    type="file"
                    id="uploadUserImage"
                    style="display:none;"
                    @change="updateUserImage($event, 'image')"
                />
              </div>
            </div>
            <template v-if="user?.activity_status">
              <svg v-if="user.is_online" width="14" height="14" viewBox="0 0 14 14" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <circle cx="7" cy="7" r="6" fill="#20D930" stroke="white" stroke-width="2"/>
              </svg>
              <svg v-else width="14" height="14" viewBox="0 0 14 14" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <circle cx="7" cy="7" r="6" fill="#C1C1C1" stroke="white" stroke-width="2"/>
              </svg>
            </template>
          </div>
          <div class="user-information">
            <div class="name-and-more">
              <p v-if="!showNameEdit" class="user-name" ref="username">{{ user.name }}</p>
              <div v-if="currentUsername" class="more">
                <BluePenIcon @click="showEditableField('name')"
                             v-if="$store.state.siteMode === 'light' && !showNameEdit" class="edit-btn"/>
                <template v-if="showNameEdit">
                  <base-input
                      v-if="showNameEdit"
                      :input-type="'text'"
                      :input-name="'name'"
                      v-model="editUser.name"
                      :style="`width:${usernameWidth}px`"
                  />
                  <img width="24" src="@assets/images/check-mark.svg" @click="saveEditableField('name')"
                       v-if="showNameEdit" class="ml-15"/>
                  <img width="20" src="@assets/images/cross-mark.svg" @click="cancelEditableField('name')"
                       v-if="showNameEdit" class="ml-15"/>
                  <img @click="showEditableField('name')" v-else class="edit-btn"
                       src="/svg/pen-white.svg"
                       alt="edit"/>
                </template>
              </div>
            </div>

            <div class="nick-section">
              <p v-if="!showUserNameEdit" class="nick" ref="nick">@{{ user.username }}</p>
              <template v-if="currentUsername">
                <BluePenIcon @click="showEditableField('username')"
                             v-if="$store.state.siteMode === 'light' && !showUserNameEdit"
                             class="edit-btn"/>
                <template v-if="showUserNameEdit">
                  <base-input
                      v-if="showUserNameEdit"
                      :input-type="'text'"
                      v-model="editUser.username"
                      :input-name="'username'"
                      class="w-200"
                      :style="`width:${nameWidth}px`"
                  />
                  <img width="24" src="@assets/images/check-mark.svg"
                       @click="saveEditableField('username')"
                       v-if="showUserNameEdit" class="ml-15"/>
                  <img width="20" src="@assets/images/cross-mark.svg"
                       @click="cancelEditableField('username')"
                       v-if="showUserNameEdit" class="ml-15"/>
                  <img @click="showEditableField('username')" v-else class="edit-btn"
                       src="/svg/pen-white.svg"
                       alt="edit"/>
                </template>
              </template>
            </div>

          </div>
        </div>
        <div class="profile_right">
          <div class="buttons">
            <template v-if="!currentUsername">
              <BaseButton class="primary follow-btn" @click="followUser">
                {{
                  followingState === null ? (following ? 'Unfollow' : '+Follow') : (followingState ? '+Follow' : 'Unfollow')
                }}
              </BaseButton>
              <BaseButton class="secondary" @click="surpriseGift">
                Custom Gift
              </BaseButton>
            </template>
            <template v-else>
              <BaseButton class="primary follow-btn" @click="createStatus = true">+Create</BaseButton>
              <BaseButton v-if="authenticated" class="secondary" @click="copyProfileUrl(authUser.username)">
                Copy Profile Url
              </BaseButton>
            </template>
          </div>
          <ul class="user_stats">
            <li>{{ user?.followers?.length }} <span>Followers</span></li>
            <li>
              <template v-if="user?.display_rank_on_profile">
                #{{ user?.rank }}
              </template>
              <template v-else>
                <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M3.046 6.223C2.11046 7.32718 1.41382 8.6132 1 10C2.292 14.338 6.31 17.5 11.066 17.5C12.059 17.5 13.019 17.362 13.929 17.105M5.294 4.228C7.00662 3.09781 9.01408 2.49682 11.066 2.5C15.822 2.5 19.839 5.662 21.131 9.998C20.4229 12.3673 18.903 14.4115 16.838 15.772M5.294 4.228L2.066 1M5.294 4.228L8.944 7.878M16.838 15.772L20.066 19M16.838 15.772L13.188 12.122C13.4666 11.8434 13.6876 11.5127 13.8384 11.1486C13.9892 10.7846 14.0668 10.3945 14.0668 10.0005C14.0668 9.6065 13.9892 9.21636 13.8384 8.85235C13.6876 8.48834 13.4666 8.1576 13.188 7.879C12.9094 7.6004 12.5787 7.3794 12.2146 7.22863C11.8506 7.07785 11.4605 7.00025 11.0665 7.00025C10.6725 7.00025 10.2824 7.07785 9.91835 7.22863C9.55434 7.3794 9.2236 7.6004 8.945 7.879M13.187 12.121L8.946 7.88"
                      stroke="#0B254E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </template>
              <span>Rank</span>
            </li>
            <li>{{ user?.role_id === 1 ? user?.received : user?.sent }}
              <span>Gifts {{ user?.role_id === 1 ? 'Received' : 'Sent' }}</span></li>
          </ul>
        </div>
      </div>

      <div class="profile-content">

        <div v-if="user?.wishlists?.length">
          <div v-if="authUser.id === user.id" class="user_products">
            <draggable v-model="user.wishlists" tag="transition-group" item-key="id" @change="changeOrder" handle=".handle">
              <template #item="{element}">
                <UserProduct :product="element" :creator="user" :is-creator="true" @edit="editWish" @delete="deleteProduct"/>
              </template>
            </draggable>
          </div>
          <div v-else class="user_products">
            <UserProduct v-for="product in user?.wishlists" :key="product.id" :product="product" :creator="user"
                         @edit="editWish" @delete="deleteProduct"/>
          </div>
        </div>
        <div v-else class="no_gifts">
          <img src="@/assets/images/no_gifts.png" alt="No gifts">
          <p>No gifts to see here yet!</p>
        </div>
      </div>
    </div>

    <IndexLeaderboard/>

    <SurpriseGift
        :class="{active: surpriseModalStatus}"
        @close="surpriseModalStatus = false"
        @surprise-purchase="surprisePurchase"
        :user="user"
    />

    <SurpriseGiftPurchase
        v-if="surprisePurchaseModalStatus"
        @close="surprisePurchaseModalStatus = false"
        :user="user"
        :gift="gift"
        @gift-purchased="giftPurchased"
    />

    <CreateModal
        v-if="createStatus"
        @close="closeModal"
        :edit-wish="editWishItem"
    />

    <ReportModal
        :class="{active: reportStatus}"
        @close="reportStatus = false"
        :id="user?.id"
    />

    <CopyWishlistModal
        :class="{active: copyWishlistStatus}"
        @close="copyWishlistStatus = false"
        :name="user?.name"
        :product="copiedProduct"
    />

  </div>
</template>

<script setup>
import "./ProfilePage.scss";
import IndexLeaderboard from '../PageIndex/IndexLeaderboard/IndexLeaderboard.vue';
import BluePenIcon from '@/assets/svg/BluePenIcon.vue';
import SurpriseGift from "@/router/components/modals/SurpriseGift.vue";
import SurpriseGiftPurchase from "@/router/components/modals/SurpriseGiftPurchase.vue";
import BaseInput from "../../UI/BaseInput";
import UserProduct from "@/router/components/profile/UserProduct.vue";
import BackIcon from "@/router/components/icons/BackIcon.vue";
import BaseButton from "@/router/UI/BaseButton.vue";
import CreateModal from "@/router/components/dashboard/CreateModal.vue";
import ReportModal from "@/router/components/modals/ReportModal.vue";
import CopyWishlistModal from "@/router/components/dashboard/CopyWishlistModal.vue";
</script>

<script>
import {mapGetters, mapActions} from "vuex";
import currencyHelper from "@/mixins/currencyHelper";
import preloader from "@/mixins/preloader";
import x from "@/mixins/x";
import draggable from 'vuedraggable'


export default {
  name: 'ProfilePage',
  components: {
    draggable
  },
  data() {
    return {
      dragging: false,
      editUser: {
        name: null,
        username: null,
        image: null,
      },
      showUserNameEdit: false,
      showNameEdit: false,
      createStatus: false,
      reportStatus: false,
      editWishItem: false,
      copyWishlistStatus: false,

      // User profile variables
      user: {},
      surpriseModalStatus: false,
      surprisePurchaseModalStatus: false,
      gift: null,
      followingState: null,
      actions: false
    }
  },
  mixins: [currencyHelper, preloader, x],
  watch: {
    createStatus(val) {
      if (val) {
        document.body.classList.add("hidden");
      } else {
        document.body.classList.remove("hidden");
      }
    },
    copiedProduct(val) {
      if (val) {
        this.copyWishlistStatus = true;
      }
    },
  },
  mounted() {
    if (this.$route.params.username) {
      this.getUserProfile()
    } else {
      this.user = this.authUser
      this.setLoading(false)
    }
  },
  computed: {
    ...mapGetters({
      currency: "currency",
      path: 'path',
      authUser: 'auth/user',
      authenticated: 'auth/authenticated',
    }),
    usernameWidth() {
      return this.$refs.username.offsetWidth;
    },
    nameWidth() {
      return this.$refs.nick.offsetWidth;
    },
    currentUsername() {
      return this.authUser && this.authUser.username === this.$route.params.username || false;
    },
    following() {
      return !!(this.authUser.favorites && this.authUser.favorites.find(e => e.id === this.user.id));
    },
    blocked() {
      return !!(this.authUser.blocked_users && this.authUser.blocked_users.includes(this.user.id));
    },
    copiedProduct() {
      if (this.$route.query.product && this.user?.wishlists?.length) {
        return this.user.wishlists.find(e => e.id === parseInt(this.$route.query.product))
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions({updateUser: 'auth/login'}),
    editUserImage() {
      document.getElementById("uploadUserImage").click();
    },
    updateUserImage(e, field) {
      const file = e.target.files[0];
      if (field === 'image') {
        this.user.avatar = URL.createObjectURL(file);
      } else if (field === 'background_image') {
        this.user.background = URL.createObjectURL(file);
      }
      let formData = new FormData();
      formData.append('field_value', file);
      formData.append('field', field);
      this.axios.post('user/edit', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((res) => {
        this.toast.info(res.data.message);
      }).catch((res) => {
        this.toast.error(res.response.data.message);
      });
    },
    editUserBackgroundImage() {
      document.getElementById("uploadUserBackgroundImage").click();
    },
    showEditableField(field) {
      switch (field) {
        case 'username':
          this.editUser.username = this.user.username
          this.showUserNameEdit = true
          break;
        case 'name':
          this.editUser.name = this.user.name
          this.showNameEdit = true
          break;
      }
    },
    saveEditableField(field) {
      switch (field) {
        case 'username':
          this.showUserNameEdit = false
          this.user.username = this.editUser.username
          this.updateFieldRequest(field, this.editUser.username);
          break;
        case 'name':
          this.showNameEdit = false
          this.user.name = this.editUser.name
          this.updateFieldRequest(field, this.editUser.name);
          break;
      }
    },
    cancelEditableField(field) {
      switch (field) {
        case 'username':
          this.showUserNameEdit = false;
          this.editUser.username = this.user.username;
          break;
        case 'name':
          this.showNameEdit = false;
          this.editUser.name = this.user.name;
          break;
      }
    },
    updateFieldRequest(field, field_value) {
      this.axios.post('user/edit', {
        field: field,
        field_value: field_value
      }).then((res) => {
        this.toast.info(res.data.message);
      }).catch((res) => {
        this.toast.error(res.response.data.message);
      });
    },
    editWish(item) {
      this.editWishItem = item
      this.createStatus = true
    },
    closeModal() {
      this.createStatus = false
      this.editWishItem = false
    },
    getUserProfile() {
      this.setLoading(true)
      this.axios.get(`${this.path}get-user/${this.$route.params.username}`)
          .then((res) => {
            this.user = res.data.user
          }).catch(() => {
        this.$router.push({name: 'home'});
      }).finally(() => {
        this.setLoading(false)
      })
    },
    followUser() {
      if (this.authenticated) {
        this.setLoading(true)
        this.axios.post('user/follow', {
          id: this.user.id
        }).then((res) => {
          this.getUserProfile()
          this.followingState = res.data.status !== 'Follow'
        }).catch((res) => {
          this.toast.error(res.data.message)
        })
      } else {
        this.$router.push({name: 'login'})
      }
    },
    surpriseGift() {
      this.surpriseModalStatus = true
    },
    surprisePurchase(gift) {
      this.gift = gift
      this.surpriseModalStatus = false
      this.surprisePurchaseModalStatus = true
    },
    giftPurchased() {
      this.surprisePurchaseModalStatus = false
    },
    back() {
      if (Object.keys(this.authUser).length) {
        this.$router.push({name: 'dashboard'});
      } else {
        this.$router.push({name: 'home'});
      }
    },
    copyProfileUrl(username = false) {
      const el = document.createElement('textarea');
      el.value = username ? window.location.origin + '/' + username : window.location.href;
      document.body.appendChild(el);
      const scrollY = window.scrollY;
      const bodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      try {
        el.select();
        document.execCommand('copy');
        this.toast.info('Profile URL copied to clipboard');
      } catch (err) {
        this.toast.error('Failed to copy profile URL');
      } finally {
        document.body.removeChild(el);
        window.scrollTo(0, scrollY);
        document.body.style.overflow = bodyOverflow;
      }
    },
    copyXUrl() {
      window.open('https://x.com/' + this.user.x_nickname, '_blank');
    },
    blockUser() {
      this.axios.post('block', {
        user_id: this.user.id
      }).then((res) => {
        this.updateUser()
        this.toast.info(res.data.message);
      }).catch((res) => {
        this.toast.error(res.response.data.message);
      });
    },
    deleteProduct(id) {
      this.axios.post('wishlists/delete', {id}).then(() => {
        this.updateUser()
        this.toast.info('Wish deleted successfully')
      }).catch((res) => {
        this.toast.error(res.response.data.message);
      })
    },
    changeOrder() {
      let wishlist_ids = [];
      for (let i = 0; i < this.user.wishlists.length; i++) {
        wishlist_ids.push(this.user.wishlists[i].id)
      }

      this.axios.post('wishlists/order', { wishlist_ids });
    }
  },
}
</script>
